import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
let auditSetting_select = class auditSetting_select extends Vue {
  deleteLogic(index) {
    this.$emit("delete");
  }
  ifItemChange(value, index) {
    console.log("ifItemChange", value, index);
    if (value) {
      let oifItemIndex = this.noneDecoItems.findIndex(item => {
        return item.data.id == value;
      });
      if (oifItemIndex >= 0) {
        this.logicItem.ifItemIndex = oifItemIndex;
        const oifItem = this.noneDecoItems[oifItemIndex];
        this.logicItem.itemOptions = [];
        this.logicItem.compareItem = "";
        this.logicItem.compareOptions = [];
        this.logicItem.ifItemOptions = oifItem.data.optionsList;
        this.logicItem.ifItemIsRadio = oifItem.data.type == 1 || oifItem.data.type == 9;
      }
    }
  }
  compareItemChange(value, index) {
    console.log("ifItemChange", value, index);
    if (value) {
      let itemindex = this.noneDecoItems.findIndex(item => {
        return item.data.id == value;
      });
      if (itemindex >= 0) {
        this.logicItem.compareItemIndex = itemindex;
        const ocompareItem = this.noneDecoItems[itemindex];
        this.logicItem.compareOptions = [];
        this.logicItem.compareItemOptions = ocompareItem.data.optionsList;
        this.logicItem.compareItemIsRadio = ocompareItem.data.type == 1 || ocompareItem.data.type == 9;
      }
    }
  }
  validateIfItem(rule, value, callback) {
    let ifitemExist = this.ifItems.some(nitem => {
      return nitem.data.id == value;
    });
    if (!ifitemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemOptions(rule, value, callback) {
    let logicIndex = rule.field.split(".")[1];
    let ifItemOptions = this.logicItem.ifItemOptions;
    const itemExist = value.every(id => {
      return ifItemOptions.some(op => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemCompareOptions(rule, value, callback) {
    let logicIndex = rule.field.split(".")[1];
    let ifItemOptions = this.logicItem.compareItemOptions;
    const itemExist = value.every(id => {
      return ifItemOptions.some(op => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], auditSetting_select.prototype, "visible", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], auditSetting_select.prototype, "disabled", void 0);
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], auditSetting_select.prototype, "logicItem", void 0);
__decorate([Prop({
  type: Array,
  default() {
    return [];
  }
})], auditSetting_select.prototype, "ifItems", void 0);
__decorate([Prop({
  type: Array,
  default() {
    return [];
  }
})], auditSetting_select.prototype, "noneDecoItems", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], auditSetting_select.prototype, "index", void 0);
auditSetting_select = __decorate([Component({
  name: "auditSetting_select",
  components: {},
  filters: {}
})], auditSetting_select);
export default auditSetting_select;